<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Customer-List",
  path: "list",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
